<script>
import { defineComponent, h } from 'vue';
import { useVoiceCalls } from 'dashboard/composables/useVoiceCalls';
import Facebook from './channels/Facebook.vue';
import Website from './channels/Website.vue';
import Twitter from './channels/Twitter.vue';
import Api from './channels/Api.vue';
import Email from './channels/Email.vue';
import Sms from './channels/Sms.vue';
import Whatsapp from './channels/Whatsapp.vue';
import WhatsappCall from './channels/WhatsappCall.vue';
import Line from './channels/Line.vue';
import Telegram from './channels/Telegram.vue';
import Max from './channels/Max.vue';
import GreenApiMax from './channels/GreenApiMax.vue';
import GreenApiWhatsapp from './channels/GreenApiWhatsapp.vue';
import GreenApiTelegram from './channels/GreenApiTelegram.vue';
import TelegramPersonal from './channels/TelegramPersonal.vue';
import MaxPersonal from './channels/MaxPersonal.vue';
import Marketplace from './channels/Marketplace.vue';
import Instagram from './channels/Instagram.vue';
import Vk from './channels/Vk.vue';
import Tiktok from './channels/Tiktok.vue';
import Voice from './channels/Voice.vue';

const channelViewList = {
  facebook: Facebook,
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  whatsapp: Whatsapp,
  whatsapp_call: WhatsappCall,
  line: Line,
  telegram: Telegram,
  max: Max,
  green_api_max: GreenApiMax,
  green_api_whatsapp: GreenApiWhatsapp,
  green_api_telegram: GreenApiTelegram,
  telegram_personal: TelegramPersonal,
  max_personal: MaxPersonal,
  yandex_market: Marketplace,
  ozon: Marketplace,
  wildberries: Marketplace,
  rocketdata: Marketplace,
  instagram: Instagram,
  vk: Vk,
  tiktok: Tiktok,
  voice: Voice,
};

// Channels that only exist once calls are launched. The channel list already
// hides their cards, but the route is reachable by a direct link.
const VOICE_CHANNELS = ['voice', 'whatsapp_call'];

export default defineComponent({
  name: 'NewChannelView',
  props: {
    channelName: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { isVoiceCallsVisible, redirectIfVoiceCallsHidden } = useVoiceCalls();

    if (VOICE_CHANNELS.includes(props.channelName)) {
      redirectIfVoiceCallsHidden('settings_inbox_new');
    }

    return { isVoiceCallsVisible };
  },
  render() {
    // The redirect waits for the account to load; render nothing meanwhile so
    // the creation form never flashes.
    if (
      VOICE_CHANNELS.includes(this.channelName) &&
      !this.isVoiceCallsVisible
    ) {
      return null;
    }

    const ChannelComponent = channelViewList[this.channelName];
    return ChannelComponent ? h(ChannelComponent) : null;
  },
});
</script>
